import { useState } from "react";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "@heroui/react";
import { fetchWithAuth } from "shared/api/fetch-with-auth";
import { API_URL } from "constants/index";
import { useSession } from "@clerk/clerk-react";
import { toast } from "react-toastify";
import { EmailTemplate } from "./types";

interface DeleteTemplateModalProps {
  isOpen: boolean;
  onClose: () => void;
  template: EmailTemplate | null;
  onSuccess: () => void;
}

export const DeleteTemplateModal: React.FC<DeleteTemplateModalProps> = ({
  isOpen,
  onClose,
  template,
  onSuccess
}) => {
  const { session } = useSession();
  const [isLoading, setIsLoading] = useState(false);

  const handleDelete = async () => {
    if (!template) return;

    setIsLoading(true);
    try {
      const response = await fetchWithAuth(
        `${API_URL}/mail-templates/${template.id}`,
        { method: "DELETE" },
        session
      );

      if (response.ok) {
        toast.success("E-mail sjabloon succesvol verwijderd");
        onClose();
        onSuccess();
      } else {
        toast.error("Fout bij verwijderen van sjabloon");
      }
    } catch (error) {
      console.error("Error deleting template:", error);
      toast.error("Fout bij verwijderen van sjabloon");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose}
      size="md"
    >
      <ModalContent>
        <ModalHeader>
          <h3 className="text-lg font-semibold text-danger">Sjabloon verwijderen</h3>
        </ModalHeader>
        <ModalBody>
          <p>
            Weet je zeker dat je het sjabloon <strong>"{template?.subject}"</strong> wilt verwijderen? 
            Deze actie kan niet ongedaan worden gemaakt.
          </p>
        </ModalBody>
        <ModalFooter>
          <Button variant="light" onPress={onClose}>
            Annuleren
          </Button>
          <Button 
            color="danger" 
            onPress={handleDelete}
            isLoading={isLoading}
          >
            Verwijderen
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}; 